import { formatThousandsInt } from '../../../../../utils/format/formatThousands';
import { Flex } from '../../../../layout/Flex';
import { NumberTypography } from '../../../../price/styles';
import { Typography } from '../../../../typography/Typography';
import { StatisticItemProp } from './types';

export const StatisticItem = (props: StatisticItemProp) => {
    const { title, displayValue, diffValue, diffDisplay, ...other } = props;

    return (
        <Flex
            width={{ xs: 'calc(50% - 8px)', sm: 'auto' }}
            background="var(--background-secondary)"
            p={1.5}
            mt={1}
            borderRadius={2}
            justifyContent="space-between"
            flexGrow={1}
            {...other}
        >
            <Typography variant="caption" mb={0.5}>
                {title}
            </Typography>
            <Flex
                direction="row"
                spacing={1}
                alignItems="baseline"
                maxWidth="100%"
                overflow="hidden"
            >
                <NumberTypography variant="title3" weight="bold" lines={1}>
                    {formatThousandsInt(Number(displayValue))}
                </NumberTypography>
                {diffValue ? (
                    <Typography
                        variant="caption"
                        color={diffValue >= 0 ? 'var(--color-success)' : 'var(--color-danger)'}
                    >
                        {diffDisplay}
                    </Typography>
                ) : (
                    ''
                )}
            </Flex>
        </Flex>
    );
};
